import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// SEO Optimization: Set document title dynamically (fallback, will be overridden by page-specific SEO)
document.title = "Lumiere Luxe - Luxury Salon & Spa | Best Hair, Makeup, Nail Services in Hyderabad | Madhapur | Sasha Clinics";

// SEO Optimization: Add meta description dynamically (fallback, will be overridden by page-specific SEO)
let metaDescription = document.querySelector('meta[name="description"]');
if (!metaDescription) {
  metaDescription = document.createElement('meta');
  metaDescription.setAttribute('name', 'description');
  document.head.appendChild(metaDescription);
}
metaDescription.setAttribute('content', 'Lumiere Luxe (Sasha Clinics) - Premium luxury salon & spa in Madhapur, Hyderabad. Expert hair styling, bridal makeup, nail art, facials, threading, waxing. Book your appointment today! ✨');

// SEO Optimization: Add structured data for better search engine understanding
const addStructuredData = () => {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Lumiere Luxe",
    "alternateName": "Sasha Clinics",
    "url": "https://lumiereluxe.in",
    "description": "Luxury Salon & Spa offering transformative beauty services in Hyderabad",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://lumiereluxe.in/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  });
  document.head.appendChild(script);
};

// Initialize SEO optimizations
addStructuredData();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
